import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceModule } from '../service/service.module';
import { MaterialModule } from '../common/material/material.module';
import { AppRoutingModule } from '../app-routing.module';
import { KontaktPageComponent } from './kontakt-page/kontakt-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        ServiceModule,
    ],
    declarations: [
        KontaktPageComponent,
    ],
})
export class KontaktModule {
}
